import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import StepsAddCampaigns from "./StepsAddCampaigns";
import TitleBar from "../../partials/content/TitleBar";

function AddGroupSitePublisherContainerCampaignBanner() {
  let items = [
    {
      title: "نوع کمپین",
      status: true,
      link: "/campaigns/all-type",
    },
    {
      title: "نوع کمپین بنری",
      status: true,
      link: "/campaigns/all-type-banner",
    },
    {
      title: "گروه نمایش دهنده بنری",
      status: true,
      link: "/campaigns/banner/simple/add-group-site-publisher",
    },
    {
      title: "کمپین بنری",
      status: false,
      link: "/campaigns/banner/simple/add",
    },
    {
      title: "تبلیغ بنری",
      status: false,
      link: "/campaigns/banner/add-simple",
    },
  ];
  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="گروه  نمایش دهنده بنری" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <StepsAddCampaigns items={items} />

              <div className="alert alert-secondary">
                <div className="text-center pb-2 white-space-nowrap">
                  آیا از قبل گروه نمایش دهنده ساخته اید؟
                </div>
                <div className="d-flex flex-column flex-lg-row align-items-center justify-content-center">
                  <span className="py-2 py-lg-0 pl-0 pl-lg-2">
                    <Link
                      to="/campaigns/banner/simple/add"
                      className="text-decoration-none "
                    >
                      <button className="btn btn-success ">
                        بله , ادامه بده
                      </button>
                    </Link>
                  </span>
                  <span className="pr-2">
                    <Link
                      to="/publishers/add-group/banner"
                      className="text-decoration-none "
                    >
                      <button className="btn btn-danger ">
                        خیر , الان بساز
                      </button>
                    </Link>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
export default AddGroupSitePublisherContainerCampaignBanner;
